<template>
    <div>
        <el-row style="padding: 30px 0 10px 30px;">
            <el-col :span="4">
                <span class="title-span">房间名称:</span>
                <el-input v-model="nameValue" style="width: 70%;"/>
            </el-col>
            <el-col :span="4">
                <span class="title-span">房间类型:</span>
                <el-select v-model="placeValue" placeholder="请选择" style="width: 70%" clearable>
                    <el-option
                            v-for="item in placeOption"
                            :label="item.placeName"
                            :value="item.id">
                    </el-option>
                </el-select>
            </el-col>
<!--            <el-col :span="3">-->
<!--                <span class="title-span">性别:</span>-->
<!--                <el-select v-model="genderValue" placeholder="请选择" style="width: 70%" clearable>-->
<!--                    <el-option-->
<!--                            v-for="item in genderOption"-->
<!--                            :key="item.value"-->
<!--                            :label="item.label"-->
<!--                            :value="item.value">-->
<!--                    </el-option>-->
<!--                </el-select>-->
<!--            </el-col>-->
<!--            <el-col :span="3">-->
<!--                <span class="title-span">年级:</span>-->
<!--                <el-select v-model="gradeValue" placeholder="请选择" style="width: 70%" clearable>-->
<!--                    <el-option-->
<!--                            v-for="item in gradeOption"-->
<!--                            :key="item.value"-->
<!--                            :label="item.label"-->
<!--                            :value="item.value">-->
<!--                    </el-option>-->
<!--                </el-select>-->
<!--            </el-col>-->
            <el-col :span="2" style="display: flex;justify-content: center;">
                <el-button type="primary" @click="search">查询</el-button>
            </el-col>
            <el-col :span="2">
                <el-button type="primary" @click="addNew">新增设备</el-button>
            </el-col>
        </el-row>
        <el-dialog title="绑定设备" :visible.sync="dialogFormVisible" width="55%">
            <div style="display: flex;justify-content: space-between">
                <div>
            <el-form>
                <el-form-item label="房间名称" :label-width="formLabelWidth">
                    <el-input v-model="roomForm.name" @blur="checkRoomName"></el-input>
                    <span v-show="showTips" style="color: red;">*该名称已被占用</span>
                </el-form-item>
                <el-form-item label="场所类型" :label-width="formLabelWidth">
                    <el-select v-model="roomForm.placeId" placeholder="请选择">
                        <el-option
                        v-for = "item in placeList"
                        :label = "item.placeName"
                        :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
<!--                <el-form-item label="场所类型" :label-width="formLabelWidth" >-->
<!--                    <el-radio-group v-model="roomForm.placeType" @change="changePlaceType">-->
<!--                        <el-radio :label="0">教室</el-radio>-->
<!--                        <el-radio :label="1">宿舍</el-radio>-->
<!--                    </el-radio-group>-->
<!--                </el-form-item>-->
<!--                <el-form-item label="性别" :label-width="formLabelWidth" v-show = "showGender">-->
<!--                    <el-radio-group v-model="roomForm.gender">-->
<!--                        <el-radio :label="0">男生</el-radio>-->
<!--                        <el-radio :label="1">女生</el-radio>-->
<!--                    </el-radio-group>-->
<!--                </el-form-item>-->
<!--                <el-form-item label="年级" :label-width="formLabelWidth">-->
<!--                    <el-radio-group v-model="roomForm.grade">-->
<!--                        <el-radio :label="0">高一</el-radio>-->
<!--                        <el-radio :label="1">高二</el-radio>-->
<!--                        <el-radio :label="2">高三</el-radio>-->
<!--                    </el-radio-group>-->
<!--                </el-form-item>-->
            </el-form>
                </div>
                <div style="height: 400px" v-if="dialogFormVisible">
                    <elCheckBoxTree :dataList='virtualDeviceList' :defaultChecked="checkedDevices" columns="选择电表" @checkItem="checkItemList"></elCheckBoxTree>
                </div>
                <div style="height: 400px">
                    <elCheckBoxTree :dataList='virtualWaterDeviceList' columns="选择水表" @checkItem="checkWaterItemList"></elCheckBoxTree>
                </div>
            </div>
            <div>
            </div>
            <div slot="footer" class="dialog-footer" v-if="showFooter">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="confirm('save')">确 定</el-button>
            </div>
            <div slot="footer" class="dialog-footer" v-if="!showFooter">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="confirm('edit')">确 定</el-button>
            </div>
        </el-dialog>
        <div class="roomList">
            <el-table :data="dataList" border height="802" style="width: 100%;" v-loading="loading">
<!--                <el-table-column type="selection" width="55"></el-table-column>-->
                <el-table-column type="index" width="50"></el-table-column>
                <el-table-column prop="name" label="房间名称"></el-table-column>
                <el-table-column prop="placeName" label="场所类型"></el-table-column>
<!--                <el-table-column prop="placeType" label="房间类型">-->
<!--                    <template slot-scope="scope">-->
<!--                        <span v-if="scope.row.placeType === 0">教室</span>-->
<!--                        <span v-if="scope.row.placeType === 1">宿舍</span>-->
<!--                    </template>-->
<!--                </el-table-column>-->
<!--                <el-table-column prop="gender" label="性别">-->
<!--                    <template slot-scope="scope">-->
<!--                        <span v-if="scope.row.gender === 0">男</span>-->
<!--                        <span v-if="scope.row.gender === 1">女</span>-->
<!--                    </template>-->
<!--                </el-table-column>-->
<!--                <el-table-column prop="grade" label="年级">-->
<!--                    <template slot-scope="scope">-->
<!--                        <span v-if="scope.row.grade === 0">高一</span>-->
<!--                        <span v-if="scope.row.grade === 1">高二</span>-->
<!--                        <span v-if="scope.row.grade === 2">高三</span>-->
<!--                    </template>-->
<!--                </el-table-column>-->
                <el-table-column prop="devName" label="关联电表"></el-table-column>
                <el-table-column prop="waterDevName" label="关联水表"></el-table-column>
                <el-table-column label="操作" width="250">
                    <template slot-scope="scope">
                        <el-button size="mini" type="primary" @click="updateMeter(scope.row)" plain>修改</el-button>
                        <el-button size="mini" type="danger" @click="deleteMeter(scope.row)" plain>删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!--分页-->
            <elPagination :total="total" :pageSize="pageSize" @pageindexChange="pageindexChange" @handleSizeChange="handleSizeChange" />
        </div>
    </div>
</template>

<script>
    import elCheckBoxTree from '@/components/module/tree/elCheckBoxTree.vue'
    import elPagination from "@/components/module/elComponents/elPagination.vue"
    export default{
        components: {
            elCheckBoxTree,
            elPagination
        },
        data() {
            return {
                placeList: [], //场所名称
                showGender:false,//是否显示性别选项
                showTips:false,//名称占用提示
                id:'',
                showFooter:true,
                dataList:[],
                total:0,
                pageSize:20,
                pageIndex:1,
                deviceNameList:'',
                devNos:'',
                deviceWaterNameList:'',
                devWaterNos:'',
                nameValue:'',
                placeValue:'',
                genderValue:'',
                gradeValue:'',
                placeOption:[],
                genderOption:[{label:"男生",value:0},{label: "女生",value: 1}],
                gradeOption:[{label:"高一",value:0},{label: "高二",value: 1},{label: "高三",value: 2}],
                dialogFormVisible:false,
                formLabelWidth: '100px',
                roomForm:{name:'',placeId:'',grade:'',gender:''},
                loading:false,
                room:{}
            }
        },
        computed:{
            nowUnit() {
                return this.$store.unitStore.getters.getNowUnit
            },
            checkedDevices() {
                let list = []
                if(!isempty(this.room.devNos)) {
                    let devNos = this.room.devNos.split(',')

                    if(!isempty(devNos)) {
                        devNos.forEach(item => {
                            list.push(Number(item))
                        })
                    }
                }
                return list;
            },
            virtualDeviceList() {
                if(!isempty(this.$store.deviceStore.getters.getDeviceTreeByappTypeNos(1001))) {

                    return [deviceList(this.$store.deviceStore.getters.getDeviceTreeByappTypeNos(1001))]
                }
            },
            virtualWaterDeviceList() {
                //return [deviceList(this.$store.deviceStore.getters.getDeviceTreeByappTypeNos(1002))]
                return []
            }
        },
        mounted() {
            this.search()
            //加载场所类型
            this.getPlace()
        },
        methods: {
            getPlace() {
                this.$api.deviceApi.getPlaceName(this.nowUnit.id,'',res => {
                    this.placeList = res
                    this.placeOption = res
                })
            },
            changePlaceType(value) {
                if(value == 0) {
                    this.showGender = false;
                    this.roomForm.gender = '';
                }
                if(value == 1) {
                    this.showGender = true;
                }
            },
            //检查名称是否重复
            checkRoomName(){
                if(!isempty(this.roomForm.name)) {
                    this.$api.deviceApi.checkRoomName(this.roomForm.name,res => {
                        this.showTips = false;
                    },res => {
                        this.showTips = true;
                    })
                }
            },
            addNew() {
                this.showTips = false;
                this.dialogFormVisible = true;
                this.showFooter = true;
                this.room = {};
                this.roomForm = {};
                this.id = "";
            },
            updateMeter(item) {
                //debugger
                this.room = item;
                this.roomForm.name = item.name;
                this.roomForm.placeId = item.placeId;
                this.dialogFormVisible = true;
                this.showFooter = false;
                this.id = item.id;

            },
            deleteMeter(item) {
                this.$confirm("确认删除房间："+item.name+'的信息？',{
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                this.$api.deviceApi.deleteByroomId(item.id,res => {
                    this.$message({
                        type:'success',
                        message:res
                    });
                    this.search()
                },res => {
                    this.$message(res)
                })

                })
            },
            search() {
                this.$api.deviceApi.getRoomList(this.pageIndex,this.pageSize,this.nameValue,this.placeValue,this.nowUnit.id,res => {
                    this.dataList = res.dataList;
                    this.total = res.total;

                })
            },
            cancel() {
                this.dialogFormVisible = false;
            },
            confirm(type) {
                if(isempty(this.roomForm.name)) {
                    this.$message.error("房间名称不能为空!")
                    return
                }
                if(this.showTips) {
                    this.$message.error("房间名称不能重复!")
                    return
                }
                if(isempty(this.roomForm.placeId)) {
                    this.$message.error("场所类型不能为空!")
                    return
                }
                // if(isempty(this.roomForm.grade)) {
                //     this.$message.error("年级不能为空!")
                //     return
                // }
                //
                // if(this.roomForm.placeType == 1) {
                //     if(isempty(this.roomForm.gender)) {
                //         this.$message.error("性别不能为空!")
                //     }
                // }
                this.dialogFormVisible = false;
                if(type == 'save') {
                    //绑定设备
                    this.$api.deviceApi.saveDeviceForRoom(this.roomForm.name,this.roomForm.placeId,
                        this.nowUnit.id,this.devNos,this.devWaterNos,res =>{
                            this.$message({
                                message: '保存成功',
                                type: 'success'
                            })
                            this.search();
                            },res => {
                                this.$message.error('保存失败')
                            });
                    //清空
                    this.roomForm = {};
                    this.devNos = '';
                    this.devWaterNos = '';
                }
                //修改配置
                if(type == 'edit') {
                    this.$api.deviceApi.updateDeviceForRoom(this.id,this.roomForm.name,this.roomForm.placeType,this.roomForm.grade,
                    this.roomForm.gender,this.devNos,this.devWaterNos,res => {
                        this.$message({
                            message: '修改成功',
                            type: 'success'
                        })
                            //刷新
                            this.search();
                        },res => {
                            this.$message.error('修改失败')
                        })
                }

            },
            checkItemList(list) {
                //debugger
                this.deviceNameList = ''
                this.devNos=''
                list.forEach((item, i) => {
                    if(item.type == 'virtualDevice') {
                        if(i + 1 < list.length) {
                            this.deviceNameList += item.label + ','
                            this.devNos += item.no + ','
                        } else {
                            this.deviceNameList += item.label
                            this.devNos += item.no
                        }
                    }
                })
            },
            checkWaterItemList(list) {
                //debugger
                this.deviceWaterNameList = ''
                this.devWaterNos=''
                list.forEach((item, i) => {
                    if(item.type == 'virtualDevice') {
                        if(i + 1 < list.length) {
                            this.deviceWaterNameList += item.label + ','
                            this.devWaterNos += item.no + ','
                        } else {
                            this.deviceWaterNameList += item.label
                            this.devWaterNos += item.no
                        }
                    }
                })
            },
            //当前页
            pageindexChange(val) {
                this.pageIndex = val;
                this.search();
            },
            //页大小
            handleSizeChange(val) {
                this.pageSize = val;
                this.pageIndex = 1;
                this.search();
            },
        }
    }

</script>

<style scoped>
    >>>.el-table th>.cell {
        font-size: 14px;
    }
    .title-span {
        display:inline-block;
        width: 30%;
        text-align: center;
        font-size: 16px;
    }
    .el-select>.el-input {
        width: 100%;
    }
</style>